export default __webpack_public_path__ + "static/media/Videtorrium.64bb1f3e.JPG";